export enum ApisStatus {
    Reset = 'RESET',
    Failed = 'DISABLED',
    Success = 'ENABLED'
}
